import { AO } from "@/settings"

const HB_ROUTES = {
  forward: "https://state-1.forward.computer",
  af: "https://hb.zoao.dev",
}

export const getHBBaseUrl = (process: string) => {
  if ([AO].includes(process)) {
    return HB_ROUTES.forward
  }

  return HB_ROUTES.af
}
